import { slendidWlusInitial } from './initial/flow';
import { slendidWlusMonthly } from './followup/flow';

export const SlendidWeightlossFlows = {
  slendidWlusInitial,
  slendidWlusMonthly
};
